import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div className="position-relative">
      <button 
        className="btn btn-transparent text-white p-0 me-3" 
        onClick={toggleDropdown}
        style={{ border: 'none', background: 'none' }}
        aria-label="Выбор языка / Language selector"
      >
        <div className="d-flex align-items-center">
          <FaGlobe className="text-primary" style={{ fontSize: '1.5rem' }} />
        </div>
      </button>

      {isOpen && (
        <div 
          className="position-absolute end-0 mt-2 py-2 bg-transparent border border-primary rounded shadow-lg" 
          style={{ 
            zIndex: 1000, 
            minWidth: '120px',
            backgroundColor: 'rgba(0, 35, 54, 0.95)'
          }}
        >
          <button
            className={`d-flex align-items-center w-100 px-3 py-2 border-0 bg-transparent ${i18n.language === 'en' ? 'text-primary' : 'text-white'}`}
            onClick={() => {
              i18n.changeLanguage('en');
              setIsOpen(false);
            }}
            style={{ cursor: 'pointer' }}
          >
            <img 
              src="https://flagcdn.com/w20/gb.png"
              srcSet="https://flagcdn.com/w40/gb.png 2x"
              width="20" 
              alt="English"
              className="me-2"
            />
            English
          </button>
          <button
            className={`d-flex align-items-center w-100 px-3 py-2 border-0 bg-transparent ${i18n.language === 'ru' ? 'text-primary' : 'text-white'}`}
            onClick={() => {
              i18n.changeLanguage('ru');
              setIsOpen(false);
            }}
            style={{ cursor: 'pointer' }}
          >
            <img 
              src="https://flagcdn.com/w20/ru.png"
              srcSet="https://flagcdn.com/w40/ru.png 2x"
              width="20" 
              alt="Russian"
              className="me-2"
            />
            Русский
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;